/**
* Created by kongwm.kong on 2017/7/25.
*/
<template>
    <div class="fund-table-wrap">
        <table :class="{'fund-table': true, 'table1':isJoined ==2}">
            <thead>
            <tr>
                <th class="th1">操作</th>
                <!--<th  class="th2">经理id</th>-->
                <th class="th3">姓名</th>
                <th  class="th4">任职公司</th>
                <th class="th5">职位</th>
                <th  class="th6">人员类别</th>
                <th class="th7">任职年限</th>
                <th  class="th8">电话</th>
                <th  class="th9">更新日期</th>
                <th  class="th10">审核状态</th>
                <th  class="th11">审核意见</th>
            </tr>
            </thead>
            <tbody v-show="!noDataShow">
            <tr v-for="(item , index) in listData">
                <td class="th1" v-if="isJoined==2"><router-link :to="{name: 'managerDetail', params: {id: item.id, type: isJoined}}">编辑</router-link></td>
                <td class="th1" v-else><router-link :to="{name: 'managerDetail', params: {id: item.fundDcId, type: isJoined}}">编辑</router-link></td>
                <!--<td class="th2">P5pqj0owxu</td>-->
                <td class="th3">{{item.name}}</td>
                <td class="th4">{{item.comName}}</td>
                <td class="th5">{{item.position}}</td>
                <td class="th6">{{item.personnelType | peopleType}}</td>
                <td class="th7">{{item.workSeniority}}</td>
                <td class="th8">{{item.phone}}</td>
                <td class="th9">{{item.updateTime | setTime('yyyy-mm-dd')}}</td>
                <td  class="th10">{{item.auditStatus | getAuditStatus}}</td>
                <td  class="th11">{{item.auditComment}}</td>
            </tr>
            </tbody>
        </table>
        <div class="page_wrap" v-show="!noDataShow && showPage">
            <paginate
                    :pageCount="pageCount"
                    :containerClass="'pagination'"
                    :clickHandler="changePage"
                    :pageRange="5"
                    :marginPages="1"
                    :prevText="'&lt;'"
                    :nextText="'&gt;'"
                    :initialPage="initialPage"
                    :pageClass="'page-item'"
            ></paginate>
            <page-jump :showPage="showPageJump" @pageJump="pageJump" :pageNum="getPageJumpNum"></page-jump>
        </div>
        <!--无数据-->
        <no-data :noDataShow="noDataShow"></no-data>
    </div>

</template>
<script>
    import noData from '../../components/common/noData';
//    import Paginate from 'vuejs-paginate';
    import Paginate from '../../components/middleware/Paginate'
    import pageJump from '../../components/middleware/page-jump'
    export default {
        props: {
            isJoined:{
                required: true
            },
            isSearch: {},
            noParams:{  //不加后面的参数
                type: Boolean,
                default: true
            },
            managerName: {}
        },
        components:{
            noData,
            Paginate,
            pageJump
        },
        data(){
            return{
                noDataShow: false,
                showPage:false,
                currPage: 1,
                listData: [],
                pageCount: 0,
                showPageJump: false,
                pageJumpNum: 5,
            }
        },
        computed:{
            getId(item){
                if(this.isJoined == 1){
                    return item.fundDcId;
                } else {
                    return item.id;
                }
            },
            getPageJumpNum(){
                if( this.pageCount > 5 ){
                    this.showPageJump = true;
                    this.pageJumpNum = Math.ceil(this.currPage / 5) * 5;
                    if(this.pageJumpNum > this.pageCount){
                        this.pageJumpNum = this.pageCount;
                    }else if(this.currPage == this.pageJumpNum &&this.pageJumpNum + 5 <  this.pageCount){
                        this.pageJumpNum = this.pageJumpNum + 5;
                    }
                } else {
                    this.showPageJump = false;
                }
                return  this.pageJumpNum;
            },
            initialPage(){
                return  this.currPage-1;
            }
        },
        mounted(){
            this.$store.commit('getLoginInfo',  this.getJoined);
//            this.getJoined();
        },
        methods:{
            getJoined(){
                let flag = 'report';
                if(this.isJoined == 1){ //已加入
                    flag = 'result';
                }
                this.getCompanyList(flag);
            },
            /*请求list*/
            getCompanyList(flag){
                let url = `/manager/${flag}/page?pageNo=${this.currPage}&pageSize=10`;
                if(this.managerName != ''  && !this.noParams){
                    url = `/manager/${flag}/page?name=${this.managerName}&pageNo=${this.currPage}&pageSize=10`;
                }
                this.$http.request({
                    url: url
                }, response => {
                    let data =  response.data;
                    if(data.code===200){
                        let listData = data.data;
                        if(listData.total && listData.list && listData.list.length){
                            this.listData = listData.list;
                            this.pageCount = Math.ceil(listData.total/ 10);
                            this.noDataShow = false;
                            if(this.pageCount<2){
                                this.showPage = false;
                            } else {
                                this.showPage = true;
                            }
                        } else {
                            this.noDataShow = true;
                        }
                    }else {
                        this.noDataShow = true;
                    }
                }, err => {
                    this.noDataShow = true;
                });
            },
            //改变页码
            changePage(page){
                this.currPage = page;
                this.getJoined();
            },
            /*page-jump*/
            pageJump(page){
                this.changePage(page);
            },
        },
        watch:{
            isJoined(){
                this.noDataShow = false;
                this.currPage = 1;
                this.getJoined();
            },
            isSearch(){
                this.noDataShow = false;
                this.currPage = 1;
                this.getJoined();
            }
        }
    }
</script>
<style lang="scss" type="text/scss" scoped>
    .fund-table{
        width:100%;
        padding: 0 20px;
        text-align: center;
        thead{
            background: #F4F8FF;
            font-size:16px;
            color:$c_3c3;
        }
        tbody{
            tr{
                &:nth-child(even){
                    background: #F4F8FF;
                }
                font-size: 14px;
                color:$c_666;
            }
        }
        td, th{
            padding: 20px 5px;
            line-height:1.6;
            word-wrap:break-word;
        }
        &.table1{
            .th10,.th11{
                display: table-cell;
            }
            .th11{
                width: 116px;
            }
           /* .th9{
                width:70px;
            }
            .th1{
                width:52px;
            }
            .th2{
                width:110px;
            }
            .th3{
                width:112px;
            }
            .th4{
                width:100px;
            }
            .th5{
                width:112px;
            }
            .th6{
                width:100px;
            }
            .th7{
                width:90px;
            }
            .th8{
                width:116px;
            }*/

        }
        .th10,.th11{
            display: none;
        }
        .th1{
            width:52px;
            a{
                color:$btn_408;
            }
        }
       /* .th2{
            width:130px;
            padding:0 10px;
        }
        .th3{
            width:112px;
        }
        .th4{
            width:100px;
        }
        .th5{
            width:112px;
        }
        .th6{
            width:100px;
            padding: 0 10px;
        }
        .th7{
            width:90px;
            padding: 0 10px;
        }
        .th8{
            width:70px;
            padding: 0 5px;
        }*/
        .th9{
            width:90px;
        }


    }
</style>


// WEBPACK FOOTER //
// src/views/manager/manager_table.vue